import React, {useEffect, useState} from "react";
import {mrbgStore} from "./mrbgRedux";

function MrbgCheckBoxList({formID,name,value,formStyle}){

  const
    [values,setValues] = useState( value instanceof Object? value: mrbgStore.getState().mrbgVars[value] ),
    [redFld,setRedFld] = useState( mrbgStore.getState().formsSettings[formID]?.redFld );

  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setValues(values instanceof Object? values: mrbgStore.getState().mrbgVars[values] )
      setRedFld(mrbgStore.getState().formsSettings[formID]?.redFld)
    })
    return () =>unsubscribe();
  },[]);

  return(
    <ul className={`itemFrame${redFld.includes(name)? ' '+formStyle.emptyField: ''}`}>
      {
        Object.keys(values).map((key,i)=>{
          const id = 'CL_'+formID+name.substring(0,1).toUpperCase()+name.substring(1)+i;
          return(
            <li key={key}>
              <input type="checkbox" name={`${name}[]`} className="mrbgCheckBoxList" value={key} id={id}/>
              <label className="flexRow" htmlFor={id}>
                {values[key]}
                <i className="fa-regular fa-square fa-2x"></i>
                <i className="fa-regular fa-square-check fa-2x"></i>
              </label>
            </li>
          )
        })
      }
    </ul>
  )
}
export default MrbgCheckBoxList;